/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'home',
    i18n: 'sections.home.title',
    icon: 'HomeIcon'
  },
  {
    url: null,
    name: 'paymentAndCheck',
    icon: 'CreditCardIcon',
    i18n: 'sections.paymentAndCheck.title',
    submenu: [
      {
        url: '/paymentAndCheck/payment',
        name: 'paymentAndCheckPayment',
        slug: 'paymentAndCheck-payment',
        i18n: 'sections.paymentAndCheck.payment.title',
      },
      {
        url: '/paymentAndCheck/history',
        name: 'paymentAndCheckHistory',
        slug: 'paymentAndCheck-history',
        i18n: 'sections.paymentAndCheck.history.title',
      },
      {
        url: '/paymentAndCheck/statementHistory',
        name: 'paymentAndCheckStatementHistory',
        slug: 'paymentAndCheck-statementHistory',
        i18n: 'sections.paymentAndCheck.statementHistory.title',
      }
    ]
  },
  {
    url: '/accountInfomation',
    name: 'AccountInfomation',
    i18n: 'sections.accountInfomation.title',
    icon: 'ListIcon',
  },
  {
    url: '/logout',
    name: 'logout',
    i18n: 'sections.logout.title',
    icon: 'LogOutIcon',
  }
]
